(() => {
  'use strict';

  const usf = window.usf;

  if (!usf) return;

  const NOT_TRACKED = -2147483648;
  const CONTINUE_SELLING = 1;
  const OPTION_PREFIX = 'option:';

  const norm = (value) => String(value).trim().toLowerCase();

  const isVariantSoldOut = (variant) => {
    if (variant.available === NOT_TRACKED) return false;

    return !(variant.flags & CONTINUE_SELLING) && variant.available <= 0;
  };

  const optionFilters = (sr) => {
    const filters = [];
    const active = sr.facetFilters;

    if (!active) return filters;

    for (const id of Object.keys(active)) {
      const [name, values] = active[id] || [];

      if (typeof name !== 'string' || !name.startsWith(OPTION_PREFIX)) continue;
      if (!values || !values.length) continue;

      filters.push({
        name: norm(name.slice(OPTION_PREFIX.length)),
        values: values.map(norm)
      });
    }

    return filters;
  };

  const hasAvailableMatch = (product, filters) => {
    const variants = product.variants;

    if (!variants || !variants.length) return true;

    const options = product.options || [];

    const indexes = filters.map((filter) =>
      options.findIndex((option) => option && norm(option.name) === filter.name)
    );

    let judged = false;

    for (const variant of variants) {
      let matches = true;

      for (const [position, filter] of filters.entries()) {
        const optionIndex = indexes[position];

        if (optionIndex === -1) continue;

        const valueIndex = variant.options ? variant.options[optionIndex] : null;
        const value = valueIndex == null ? null : (options[optionIndex].values || [])[valueIndex];

        if (value == null || !filter.values.includes(norm(value))) {
          matches = false;
          break;
        }
      }

      if (!matches) continue;

      judged = true;

      if (!isVariantSoldOut(variant)) return true;
    }

    return !judged;
  };

  const onUpdating = (sr) => {
    sr.soldOutMode = sr.loader;
  };

  const onDataReceived = (sr, data) => {
    if (!usf.platform || !usf.platform.isCollectionPage) return;
    if (!data || !data.items || !data.items.length) return;

    const filters = optionFilters(sr);

    if (!filters.length) return;

    const isPrepend = sr.soldOutMode === 'prev';
    const isFresh = sr.soldOutMode !== 'more' && !isPrepend;

    if (isFresh) {
      sr.soldOutDropped = 0;
      sr.soldOutServerTotal = data.total;
    }

    if (!sr.soldOutServerTotal) sr.soldOutServerTotal = data.total;

    const kept = data.items.filter((product) => hasAvailableMatch(product, filters));
    const dropped = data.items.length - kept.length;

    if (dropped) {
      data.items = kept;
      sr.soldOutDropped += dropped;

      if (!isPrepend) sr.itemsLoaded += dropped;
    }

    if (!sr.soldOutDropped) return;

    const loaded = !isFresh && sr.result && sr.result.items ? sr.result.items.length : 0;
    const visible = loaded + kept.length;
    const consumed = sr.itemsLoaded + kept.length;

    let total = sr.soldOutServerTotal - sr.soldOutDropped;

    if (consumed < sr.soldOutServerTotal && total <= consumed) total = consumed + 1;
    if (total < visible) total = visible;

    data.total = total;

    if (!isFresh && sr.result) sr.result.total = total;
  };

  const filterRendered = () => {
    const sr = usf.search;

    if (!usf.platform || !usf.platform.isCollectionPage) return;
    if (!sr || !sr.result || !sr.result.items || !sr.result.items.length) return;
    if (sr.soldOutServerTotal) return;

    const filters = optionFilters(sr);

    if (!filters.length) return;

    const kept = sr.result.items.filter((product) => hasAvailableMatch(product, filters));
    const dropped = sr.result.items.length - kept.length;

    if (!dropped) return;

    const serverTotal = sr.result.total;

    let total = serverTotal - dropped;

    if (sr.itemsLoaded < serverTotal && total <= sr.itemsLoaded) total = sr.itemsLoaded + 1;
    if (total < kept.length) total = kept.length;

    sr.soldOutServerTotal = serverTotal;
    sr.soldOutDropped = dropped;
    sr.result.items = kept;
    sr.result.total = total;
  };

  let attached = false;

  const attach = () => {
    if (attached) return true;
    if (!usf.event || !usf.event.add) return false;

    attached = true;
    usf.event.add('sr_updating', onUpdating);
    usf.event.add('sr_dataReceived', onDataReceived);
    filterRendered();

    return true;
  };

  if (!attach()) {
    usf.plugins = usf.plugins || [];
    usf.plugins.push({
      send: (config, next) => {
        attach();

        return next();
      }
    });
  }
})();
